import React, {
  createContext, useContext, useEffect, useState
} from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import { notify } from '~/helpers/Toast';
import {
  getFilterCampaigns, getFilterAttendants
} from '~/services/Generic/Dashboard';
import { getDashboard } from '~/services/User/CSAT/Dashboard';

const DashboardContext = createContext({});

function DashboardContextProvider({ children }) {
  const { t } = useTranslation();
  const [isLoadingData, setIsLoadingData] = useState(false);
  const [surveyOptions, setSurveyOptions] = useState([]);
  const [attendantsOptions, setAttendantsOptions] = useState([]);
  const [dataDashboard, setDataDashboard] = useState();
  const [filter, setFilter] = useState({
    campaign: '',
    attendant: '',
    type: 'csat',
    dates: {
      start: '',
      end: ''
    }
  });
  const history = useHistory();

  useEffect(() => {
    async function getInitialData() {
      await getFilterCampaigns(filter).then((data) => {
        if (data.length === 0) {
          history.push('/');
          notify('warning', t('notify.getFilterCampaigns.warning'));
        }

        setSurveyOptions(data);
      });

      await getFilterAttendants().then((data) => {
        setAttendantsOptions(data);
      });
    }

    getInitialData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [history, filter]);

  useEffect(() => {
    async function getData() {
      setIsLoadingData(true);

      await getDashboard(filter).then((data) => {
        setDataDashboard(data);
        setIsLoadingData(false);
      });
    }

    getData();
  }, [filter]);

  return (
    <DashboardContext.Provider value={{
      isLoadingData,
      dataDashboard,
      surveyOptions,
      attendantsOptions,
      setFilter
    }}
    >
      {children}
    </DashboardContext.Provider>
  );
}

const useDashboard = () => useContext(DashboardContext);

export { DashboardContextProvider, useDashboard };
